var _path, _rect;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6H7a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V9a3 3 0 00-3-3h-7zM5 11h18",
    stroke: "#2C2D2E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 16,
    width: 3,
    height: 3,
    rx: 1,
    fill: "#2C2D2E"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0IDZIN0M1LjM0MzE1IDYgNCA3LjM0MzE1IDQgOVYxMS4zMzMzVjE0VjE2LjY2NjdWMTlDNCAyMC42NTY5IDUuMzQzMTUgMjIgNyAyMkgxNEgyMUMyMi42NTY5IDIyIDI0IDIwLjY1NjkgMjQgMTlWMTYuNjY2N1YxNFYxMS4zMzMzVjlDMjQgNy4zNDMxNSAyMi42NTY5IDYgMjEgNkgxNFoiIHN0cm9rZT0iIzJDMkQyRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTUgMTFIMjMiIHN0cm9rZT0iIzJDMkQyRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHJlY3QgeD0iNyIgeT0iMTYiIHdpZHRoPSIzIiBoZWlnaHQ9IjMiIHJ4PSIxIiBmaWxsPSIjMkMyRDJFIi8+Cjwvc3ZnPgo=";
export { SvgCardIcon as ReactComponent };